import React, { useState } from "react";
import { Gallery } from "react-grid-gallery";
import Lightbox from "yet-another-react-lightbox";
import { images } from "./Image";
import { Link } from "react-router-dom";

const slides = images.map(({ original }) => ({
  src: original,
}));

// console.log(slides);

const ImageScreen = () => {
  const [index, setIndex] = useState(-1);

  const handleClick = (index) => setIndex(index);
  return (
    <div className="pt-4 pb-4">
      <div className="head pt-lg-3">
        <h3>Photo Gallery</h3>
      </div>
      <div className="pt-4">
        <Gallery
          images={images}
          onClick={handleClick}
          enableImageSelection={false}
        />
        <Lightbox
          slides={slides}
          // slides={slides.map((slide) => ({
          //   ...slide,
          //   title: slide.caption || "",
          //   description: slide.caption || "",
          // }))}
          open={index >= 0}
          index={index}
          close={() => setIndex(-1)}
        />
        <div
          className="read-more-w pt-4"
          style={{
            textAlign: "right",
            paddingRight: "100px",
          }}
        >
          <Link to="/gallery">
            <button>View All</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ImageScreen;
